// ─── Date formatting ───────────────────────────────────────────────────────────
export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

export const fmtShortDate = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return (
    d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) +
    " · " +
    d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })
  );
};

// ─── Misc helpers ──────────────────────────────────────────────────────────────
export const getInitial = (handle) =>
  (handle || "?").replace(/^@/, "").charAt(0).toUpperCase();

export const normaliseHandle = (handle) =>
  "@" + (handle || "").replace(/^@/, "");

/** Parse keywords from session — either an array or comma-separated string */
export const parseKeywords = (raw) => {
  if (Array.isArray(raw)) return raw.filter(Boolean);
  return (raw || "").split(",").map((k) => k.trim()).filter(Boolean);
};

// ─── JSON syntax highlight ────────────────────────────────────────────────────
export function syntaxHighlight(obj) {
  const json = JSON.stringify(obj, null, 2)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return json.replace(
    /("(\\u[\dA-Fa-f]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+\.?\d*(?:[Ee][+-]?\d+)?)/g,
    (m) => {
      let cls = "json-number";
      if (/^"/.test(m))       cls = /:$/.test(m) ? "json-key" : "json-string";
      else if (/true|false/.test(m)) cls = "json-bool";
      else if (/null/.test(m))       cls = "json-null";
      return `<span class="${cls}">${m}</span>`;
    },
  );
}
